var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelebration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "celebration_black_24dp_1_",
    "data-name": "celebration_black_24dp (1)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11809",
    "data-name": "Group 11809"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5115",
    "data-name": "Rectangle 5115",
    width: 14,
    height: 14,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11811",
    "data-name": "Group 11811",
    transform: "translate(1.167 0.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11810",
    "data-name": "Group 11810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10908",
    "data-name": "Path 10908",
    d: "M9.413,14.292,6.77,11.65,5.3,15.763Z",
    transform: "translate(-3.375 -5.706)",
    fill: "#d23b7d",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10909",
    "data-name": "Path 10909",
    d: "M2,16.167l8.167-2.917L4.917,8Zm6.037-3.395-4.112,1.47,1.47-4.113Z",
    transform: "translate(-2 -4.185)",
    fill: "#d23b7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10910",
    "data-name": "Path 10910",
    d: "M14.088,9.425l3.261-3.261a.729.729,0,0,1,1.033,0l.344.344.618-.618L19,5.546a1.609,1.609,0,0,0-2.269,0L13.47,8.806Z",
    transform: "translate(-6.779 -2.967)",
    fill: "#d23b7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10911",
    "data-name": "Path 10911",
    d: "M9.47,5.8l.618.618.344-.344a1.609,1.609,0,0,0,0-2.269l-.344-.344-.618.624.344.344a.732.732,0,0,1,0,1.027Z",
    transform: "translate(-5.113 -2.293)",
    fill: "#d23b7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10912",
    "data-name": "Path 10912",
    d: "M16.4,11.546l-.927.927.618.618.927-.928a.729.729,0,0,1,1.033,0l.939.939.618-.618-.939-.939A1.609,1.609,0,0,0,16.4,11.546Z",
    transform: "translate(-7.612 -5.467)",
    fill: "#d23b7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10913",
    "data-name": "Path 10913",
    d: "M13.564,4.038,11.47,6.133l.618.618,2.094-2.094a1.609,1.609,0,0,0,0-2.269l-.927-.928-.618.618.927.927A.74.74,0,0,1,13.564,4.038Z",
    transform: "translate(-5.946 -1.46)",
    fill: "#d23b7d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebration);
export default __webpack_public_path__ + "static/media/celebration.d016adac577768206cde1e0dc07b6186.svg";
export { ForwardRef as ReactComponent };